<template>
    <v-container fluid class="scroll-y fullscreen" pa-0>
        <v-card
            class="mx-auto"
            flat
            :loading="loading"
            loader-height="10"
            tile
        >
            <v-toolbar
            color="#003a6f"
            dark
            flat
            >
                <v-toolbar-title v-if="!drawer">{{ pageTitle }}</v-toolbar-title>
                <v-spacer v-if="!drawer"></v-spacer>
                <v-btn
                    color="primary"
                    @click="drawer = !drawer"
                    tile
                    v-if="!drawer"
                    >
                        <v-icon dark>mdi-menu</v-icon>
                </v-btn>
                <v-btn
                    color="primary"
                    @click="drawer = !drawer"
                    tile
                    v-else
                    large min-width="100%"
                    >
                        <v-icon dark>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
        </v-card>
        <v-card flat tile class="mx-auto overflow-hidden" min-height="calc(100vh - 112px)">
            <Equipment :job="id" />
            <Drawer :show="drawer" :id="id" :cid.sync="customer" @update-drawer="updateDrawer" />
        </v-card>
    </v-container>
</template>

<script>
    //import axios from 'axios'
    import TokenService from '../../services/storage.service'
    import Drawer from './Drawer.vue'
    import Equipment from '../../components/Jobs/Equipment.vue'

    export default {
        props: ['id'],
        data () {
            return {
                loading: false,
                token: '',
                pageTitle: '',
                drawer: false,
            }
        },
        created() {
            this.token = TokenService.getToken()
            this.pageTitle = this.$route.meta.title
        },
        components: {
            Drawer,
            Equipment
        },
        methods: {
            updateDrawer(val) {
                this.drawer = val
            },
        }
    }
</script>